import React from 'react';

const ExperienceCard = () => {
  React.useEffect(() => {
    // eslint-disable-next-line no-console
    console.warn('Placeholder: ExperienceCard is not implemented yet.');
  }, []);
  return (
    <>
  { /*ExperienceCard */} 
 </>
  );
};

export default ExperienceCard;
